import React from "react";
import s from "./Shimmer.module.scss";
import { Typography } from "ui-v2/components/Typography";
import { Button } from "ui-v2/components/Button";
import Icon from "ui-v2/components/Icon/Icon";

export const Shimmer = () => {
  return (
    <div className={s.root}>
      <div className={s.loader}>
        <div className={s.icon}>
          <Icon name="LocationBold" />
        </div>
        <div className={s.text}>
          <Typography label="Please wait..." variant="label_2_bold" />
          <div className="cmn_shimmer" />
          <div className="cmn_shimmer" />
        </div>
      </div>
      <Button
        label="Fetching accurate location..."
        disabled
        fullWidth
        variant="primary"
        size="medium"
      />
    </div>
  );
};
